import { Route, Routes } from "react-router-dom";
import Layout from "./components/layout/layout";
import Confirmation from "./pages/confirmation/confirmation";
import Home from "./pages/home/home";
import Result from "./pages/result/result";
import Signup from "./pages/signup/signup";
import BusinessSignup from "./pages/signup/businessSignup";
import SignupWithInvitation from "./pages/signup/signupWithInvitation";
import Login from "./pages/login/login";
import Children from "./pages/children/children";
import Business from "./pages/business/business";
import Employees from "./pages/employees/employees";
import UserProfile from "./pages/profile/UserProfile";
import TutorProfle from "./pages/profile/TutorProfile";
import TutorProfileDashboard from "./pages/profile/TutorProfileDashboard";
import TutorEducationForm from "./pages/profile/TutorEducationForm";
import TutorExperienceForm from "./pages/profile/TutorExperienceForm";
import TutorCalendarForm from "./pages/profile/TutorCalendarForm";
import TutorLocationForm from "./pages/profile/TutorLocationForm";
import TutorReviewsPage from "./pages/profile/TutorReviewsPage";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import ResetPassword from "./pages/resetPassword/resetPassword";
import Waitlist from "./pages/waitlist/waitlist";
import './styles/style.global.css';
import DetailResult from "./pages/result/detailResult";
import AdminDashboardPage from "./pages/dashboard/dashboard";
import ApprovedRequestsPage from "./pages/dashboard/Approved/request";
import RejectedRequestsPage from "./pages/dashboard/Rejected/request";
import PendingRequestsPage from "./pages/dashboard/Pending/request";
import AprovedTutorsPage from "./pages/dashboard/Approved/tutor";
import RejectedTutorsPage from "./pages/dashboard/Rejected/tutor";
import PendingTutorsPage from "./pages/dashboard/Pending/tutor";
import AllTutorsPage from "./pages/dashboard/All/tutor";
import Request from "./pages/tutor-request/request";
import StudentRequest from "./pages/student-parent-request/request";
import EarlyAccess from "./pages/earlyAccess/earlyAccess";
import ProtectedLayout from "./components/protectedLayout/protectedLayout";
import TutorClassRoom from "./pages/class-room/tutorClassRoom";
import Detail_class_room from "./pages/class-room/detail_class_room";
import StudentClassRoom from "./pages/class-room/studentClassRoom";
import Student_Detail_class_room from "./pages/class-room/student-detail-class-room";
import SessionJoin from "./pages/session/SessionJoin";
import ScrollToTop from "./components/scrollToTop/scrollToTop";
import Tutors from "./pages/tutors/tutors";
import Parents from "./pages/parents/parents";
import Students from "./pages/students/students";
import MyQuizzes from "./pages/quiz/myQuizzes";
import CreateQuiz from "./pages/quiz/createQuiz";
import QuizDetail from "./pages/quiz/quizDetail";
import TakeQuiz from "./pages/quiz/takeQuiz";
import QuizResults from "./pages/quiz/quizResults";
import MyFlashcards from "./pages/flashcard/myFlashcards";
import CreateFlashcard from "./pages/flashcard/createFlashcard";
import FlashcardDetail from "./pages/flashcard/flashcardDetail";
import StudyFlashcards from "./pages/flashcard/studyFlashcards";
import ProgressDashboard from "./pages/progress/dashboard";
import ProtectedRoute from "./components/protectedRoute/ProtectedRoute";
import AdminRoute from "./components/adminRoute/AdminRoute";
import GuestRoute from "./components/guestRoute/GuestRoute";
import TermsAndConditions from "./pages/terms/terms";
import ServiceOutage from "./pages/serviceOutage/serviceOutage";
import { SERVICE_OUTAGE } from "./config/config";

function App() {
  if (SERVICE_OUTAGE) {
    return (
      <ScrollToTop>
        <Routes>
          <Route path="*" element={<ServiceOutage />} />
        </Routes>
      </ScrollToTop>
    );
  }

  return (
    <ScrollToTop>
      <Routes>
        {/* Public Routes - No authentication required */}
        <Route path="/early-access" element={<EarlyAccess />} />
        {/* Guest-only routes - Redirect logged-in users to homepage */}
        <Route path="/signup" element={<GuestRoute><Layout><Signup /></Layout></GuestRoute>} />
        <Route path="/signup/business" element={<GuestRoute><Layout><BusinessSignup /></Layout></GuestRoute>} />
        <Route path="/signup/invitation" element={<Layout><SignupWithInvitation /></Layout>} />
        <Route path="/terms" element={<Layout><TermsAndConditions /></Layout>} />
        <Route path="/terms-and-conditions" element={<Layout><TermsAndConditions /></Layout>} />
        <Route path="/login" element={<GuestRoute><Layout><Login /></Layout></GuestRoute>} />
        <Route path="/forgot-password" element={<GuestRoute><Layout><ForgotPassword /></Layout></GuestRoute>} />
        <Route path="/reset-password/:token" element={<GuestRoute><Layout><ResetPassword /></Layout></GuestRoute>} />

        {/* Early access restriction disabled */}
        <Route path="/" element={<ProtectedLayout authStatus={true} />}>
          {/* Public pages within early access */}
          <Route index element={<Layout><Home /></Layout>} />
          {/* Guest-only routes - Redirect logged-in users to homepage */}
          <Route path="/confirmation" element={<GuestRoute><Layout><Confirmation /></Layout></GuestRoute>} />
          <Route path="/waitlist" element={<GuestRoute><Layout><Waitlist /></Layout></GuestRoute>} />
          <Route path="/tutors" element={<Layout><Tutors /></Layout>} />
          <Route path="/parents" element={<Layout><Parents /></Layout>} />
          <Route path="/students" element={<Layout><Students /></Layout>} />
          <Route path="/business" element={<Layout><Business /></Layout>} />
          <Route path="/result" element={<Layout><Result /></Layout>} />
          <Route path="/detail-result" element={<Layout><DetailResult /></Layout>} />

          {/* Admin Routes - Require ADMIN role */}
          <Route path="/dashboard" element={<AdminRoute><AdminDashboardPage /></AdminRoute>} />
          <Route path="/request/approved" element={<AdminRoute><ApprovedRequestsPage /></AdminRoute>} />
          <Route path="/request/rejected" element={<AdminRoute><RejectedRequestsPage /></AdminRoute>} />
          <Route path="/request/pending" element={<AdminRoute><PendingRequestsPage /></AdminRoute>} />
          <Route path="/tutor/approved" element={<AdminRoute><AprovedTutorsPage /></AdminRoute>} />
          <Route path="/tutor/rejected" element={<AdminRoute><RejectedTutorsPage /></AdminRoute>} />
          <Route path="/tutor/pending" element={<AdminRoute><PendingTutorsPage /></AdminRoute>} />
          <Route path="/tutor/all" element={<AdminRoute><AllTutorsPage /></AdminRoute>} />
          <Route path="/tutor/registered" element={<AdminRoute><AllTutorsPage /></AdminRoute>} />

          {/* Tutor Routes - Require TUTOR role */}
          <Route path="/request" element={<ProtectedRoute requireRole="TUTOR"><Request /></ProtectedRoute>} />
          <Route path="/tutor-class-room" element={<ProtectedRoute requireRole="TUTOR"><TutorClassRoom /></ProtectedRoute>} />
          <Route path="/detail-class-room" element={<ProtectedRoute requireRole="TUTOR"><Detail_class_room /></ProtectedRoute>} />

          {/* Student/Parent Routes - Require STUDENT or PARENT role */}
          <Route path="/children" element={<ProtectedRoute requireRole="PARENT"><Children /></ProtectedRoute>} />
          {/* Business Routes - Require BUSINESS role */}
          <Route path="/employees" element={<ProtectedRoute requireRole="BUSINESS"><Employees /></ProtectedRoute>} />
          {/* Student/Parent/Business Routes */}
          <Route path="/student-request" element={<ProtectedRoute requireRole={["STUDENT", "PARENT", "BUSINESS"]}><StudentRequest /></ProtectedRoute>} />
          <Route path="/student-class-room" element={<ProtectedRoute requireRole={["STUDENT", "PARENT"]}><StudentClassRoom /></ProtectedRoute>} />
          <Route path="/student-detail-class-room" element={<ProtectedRoute requireRole={["STUDENT", "PARENT"]}><Student_Detail_class_room /></ProtectedRoute>} />

          {/* Session Join Route - Require authentication */}
          <Route path="/session/:sessionId/join" element={<ProtectedRoute><SessionJoin /></ProtectedRoute>} />

          {/* Profile Routes - Require authentication */}
          <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
          <Route path="/tutor-profile" element={<ProtectedRoute><TutorProfileDashboard /></ProtectedRoute>} />
          <Route path="/tutor-profile/education" element={<ProtectedRoute><TutorEducationForm /></ProtectedRoute>} />
          <Route path="/tutor-profile/experience" element={<ProtectedRoute><TutorExperienceForm /></ProtectedRoute>} />
          <Route path="/tutor-profile/calendar" element={<ProtectedRoute><TutorCalendarForm /></ProtectedRoute>} />
          <Route path="/tutor-profile/location" element={<ProtectedRoute><TutorLocationForm /></ProtectedRoute>} />
          <Route path="/tutor-profile/reviews" element={<ProtectedRoute><TutorReviewsPage /></ProtectedRoute>} />

          {/* Quiz Routes - Require authentication */}
          <Route path="/quiz/create" element={<ProtectedRoute><CreateQuiz /></ProtectedRoute>} />
          <Route path="/quiz/my" element={<ProtectedRoute><MyQuizzes /></ProtectedRoute>} />
          <Route path="/quiz/:id" element={<ProtectedRoute><QuizDetail /></ProtectedRoute>} />
          <Route path="/quiz/take/:id" element={<ProtectedRoute><TakeQuiz /></ProtectedRoute>} />
          <Route path="/quiz/results/:id" element={<ProtectedRoute><QuizResults /></ProtectedRoute>} />
          <Route path="/quiz/student" element={<ProtectedRoute><MyQuizzes /></ProtectedRoute>} />

          {/* Flashcard Routes - Require authentication */}
          <Route path="/flashcard/create" element={<ProtectedRoute><CreateFlashcard /></ProtectedRoute>} />
          <Route path="/flashcard/my" element={<ProtectedRoute><MyFlashcards /></ProtectedRoute>} />
          <Route path="/flashcard/:id" element={<ProtectedRoute><FlashcardDetail /></ProtectedRoute>} />
          <Route path="/flashcard/study/:id" element={<ProtectedRoute><StudyFlashcards /></ProtectedRoute>} />
          <Route path="/flashcard/student" element={<ProtectedRoute><MyFlashcards /></ProtectedRoute>} />

          {/* Progress Dashboard - Require authentication */}
          <Route path="/progress" element={<ProtectedRoute><ProgressDashboard /></ProtectedRoute>} />
        </Route>
      </Routes>
    </ScrollToTop>
  );
}

export default App;